module.exports = __webpack_public_path__ + "media/images/front/icon_up_green-6ee1c2148616006e0b79b29111384455.png";